import Portal = require("portal-gis");
import Collection = require("../collections/base-collection");

/**
shared features across multiple map instances
*/
let data = new Collection<Portal.FeatureLeaf>();
export = data; 